import { IndexPageOld } from './index-page-old'
import { IndexPage } from './index-page'

export { IndexPageOld, IndexPage }